export const debounce = (func, wait, immediate) => {
  let timeout;
  // Klassisches function-Statement (nicht arrow), damit `this` beim Aufruf
  // an das aufrufende Objekt gebunden bleibt — wichtig für z. B.
  // element.addEventListener(debounced), wo `this` das Element sein soll.
  // Die inneren Arrow-Funktionen erben `this` und `args` automatisch.
  return function (...args) {
    const later = () => {
      timeout = null;
      if (!immediate) func.apply(this, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(this, args);
  };
};

export function checkMobileOrDesktopHeader() {
  const headerDesktop = document.getElementById('page-header');
  const headerMobile = document.getElementById('page-header--mobile');
  let header;
  const isDisplayed = (element) => {
    if (!element) return false;
    const display = window.getComputedStyle(element).display;
    return display === 'block' || display === 'grid';
  };
  if (isDisplayed(headerDesktop)) {
    header = headerDesktop;
  } else if (isDisplayed(headerMobile)) {
    header = headerMobile;
  }
  return header;
}
